import { createSelector } from '@reduxjs/toolkit';
import { alphaSort } from 'vet-bones/utils';
import { SelectItem } from 'vet-bones/utils/select';

import { getLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { projectLabelsByIriSelector } from 'src/selectors/projectLabelsByIri';
import { DATATYPE_IRIS } from 'src/templates/queries/iris';

export const projectDatatypeItemsSelector = (projectId: string) =>
  createSelector(projectLabelsByIriSelector(projectId), (labelsByIri) =>
    DATATYPE_IRIS.map<SelectItem>((value) => ({
      value,
      text: getLabelForIri(labelsByIri, value),
    })).sort(alphaSort(({ text }) => text))
  );
